import Image from 'next/image'
import Link from 'next/link'

import clsx from 'clsx'

import { Footer } from '@ui/layout/Footer'

export function WebAuthLayout({
  className,
  title,
  heading,
  children,
  showMarketingFooter = true,
}: {
  className?: string
  title?: string
  heading?: React.ReactNode
  children?: React.ReactNode
  showMarketingFooter?: boolean
}) {

  return (
    <>
      <div className={clsx('bg-white text-black', className)}>
        <main className="flex min-h-screen overflow-hidden">
          <div className="mx-auto flex w-full max-w-xl flex-1 flex-col p-4 sm:px-4 sm:py-8">
            <div className="flex flex-1 flex-col sm:items-center sm:justify-center">
              <div className="flex flex-col items-center justify-center">
                <Link href="/">
                  <span className="sr-only">ATM.com</span>
                  <Image
                    src="/img/atm-logo.svg"
                    width={100}
                    height={63}
                    alt="ATM.com"
                    className="h-10 w-auto sm:h-12"
                  />
                </Link>
              </div>
              {heading}
              {(children || title) && (
                <div className="my-4 w-full max-w-md p-4 sm:mx-0 sm:my-8 sm:flex-none sm:py-0">
                  {title && (
                    <h2 className="font-display mb-8 text-center text-4xl text-[#0a2d4a]">
                      {title}
                    </h2>
                  )}
                  {children}
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
      {showMarketingFooter && <Footer chinColor="white" />}
    </>
  )
}
